import { useState } from "react";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";
import { Button, Input, InputGroup, InputGroupText } from "reactstrap";
import FormattedPrice from "../FormattedPrice";
import ProductStock from "../ProductStock";
import { multiply } from "../../utils/NumberUtils";
import Icon from "../Icon";
import "./style.scss";

const QuantityInput = ({
  id,
  className,
  style,
  product,
  value: initValue = 1,
  valueCallback,
  stock,
  salesUnit,
  price,
  currency,
  b2b,
  isBusiness,
  compact,
  children
}) => {
  const tp = useProductTranslations();
  const isVerySmall = useMediaQuery({ maxWidth: 599.98 });
  const stockInt = parseInt(stock) || 999;
  const [value, setValue] = useState(initValue);

  const setAmount = e => {
    if (e.target.value === "") {
      setValue("");
      valueCallback?.(0);
      return;
    }
    let newValue = parseInt(e?.target?.value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }
    setValue(newValue);
    valueCallback?.(newValue);
  };

  const total = multiply(value === "" ? 0 : value, price);
  return (
    <div
      id={id}
      className={classNames("quantity-input", className)}
      style={style}
    >
      <div className={"plus-minus-box"}>
        <Button
          onClick={() => {
            const newV = value > 0 && value !== "" ? value - 1 : value;
            setValue(newV);
            valueCallback?.(newV);
            return newV;
          }}
          disabled={value <= 1}
          color="white"
          className="step-button step-button-left"
        >
          <Icon name="minus" />
        </Button>
        <div className={"plus-minus-inner"}>
          <InputGroup>
            <Input
              type={"number"}
              value={value}
              onChange={setAmount}
              className={"quantity-input-field"}
            />
            <InputGroupText className={"quantity-input-unit"}>
              {tp("sales_unit." + salesUnit)}
            </InputGroupText>
          </InputGroup>
        </div>
        <Button
          onClick={() => {
            const newV = (value === "" ? 0 : value) + 1;
            setValue(newV);
            valueCallback?.(newV);
            return newV;
          }}
          disabled={value >= stockInt}
          color="white"
          className="step-button step-button-right"
        >
          <Icon name="plus" />
        </Button>
        {!b2b && !isBusiness && !compact && (
          <>
            <div className="price-and-stock">
              <span className="price-cell">
                <FormattedPrice price={total} currency={currency} />
              </span>
              <div className="stock-status-cell">
                <ProductStock
                  product={product}
                  b2b={b2b}
                  short={isVerySmall}
                  salesUnit={salesUnit}
                />
              </div>
              {children}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QuantityInput;
